import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DashboardComponent } from './game/dashboard/dashboard.component';
import { Dnd5eSheetComponent } from './game/dnd5e-sheet/dnd5e-sheet.component';
import { HomeComponent } from './public/home/home.component';

const routes: Routes = [
  { path: 'dashboard', component: DashboardComponent },
  { path: 'dnd5e-sheet/:id', component: Dnd5eSheetComponent },
  {
    path: 'home',
    component: HomeComponent,
    // data: { title: 'Welcome to Beyond Tabletop' }
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' }
  // { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /Users/traev/Sites/btt/src/app/app-routing.module.ts